module.exports = __webpack_public_path__ + "static/media/papertrail-logo.21679171.svg";